import {
    GET_LIST_INTERACTION_STATUS,
    GET_SPECIFIC_INTERACTION_STATUS,
    UPDATE_SPECIFIC_INTERACTION_STATUS,
    CREATE_NEW_INTERACTION_STATUS,
    REMOVE_INTERACTION_STATUS,
    GET_INTERACTION_STATUS_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    interactionStatusList: [],
    currentInteractionStatus: null,
    interactionStatusActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_INTERACTION_STATUS: {
            return {
                ...state,
                interactionStatusList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_INTERACTION_STATUS_ACTIVE: {
            return {
                ...state,
                interactionStatusActiveList: action.payload?.data || [],
            }
        }
        case GET_SPECIFIC_INTERACTION_STATUS: {
            return { ...state, currentInteractionStatus: action.payload }
        }
        case CREATE_NEW_INTERACTION_STATUS: {
            return {
                ...state,
                interactionStatusList: [action.payload, ...state.interactionStatusList],
                interactionStatusActiveList: [action.payload, ...state.interactionStatusActiveList],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_INTERACTION_STATUS: {
            let index = state.interactionStatusList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.interactionStatusList];
            temp[index] = action.payload;
            //
            let index2 = state.interactionStatusActiveList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp2 = [...state.interactionStatusActiveList];
            temp[index2] = action.payload;

            return { ...state, interactionStatusList: temp, interactionStatusActiveList: temp2 }
        }
        case REMOVE_INTERACTION_STATUS: {
            let temp = state.interactionStatusList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.interactionStatusActiveList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, interactionStatusList: temp, interactionStatusActiveList: temp2 }
        }
        default: return { ...state };
    }
}
